export default {
    intro: 'Dùng gợi ý phụ âm đầu và nghĩa để suy luận từ vựng!',
    meaning: 'Nghĩa',
    example: 'Ví dụ',
    table: {
        question: 'Từ vựng',
        emptyMessage: 'Không có nội dung.',
        answerRate: 'Tỷ lệ đúng',
    },
    student: {
        selectionGuide: 'Bạn có thể đoán được từ vựng từ những gợi ý này không?',
        know: 'Tôi biết!',
        dontKnow: 'Tôi không biết',
        submit: 'Gửi',
        next: 'Tiếp theo',
        inputGuide: 'Hãy nhập từ vựng bạn nghĩ đến!',
        inputPlaceholder: 'Nhập câu trả lời',
        meaningN: 'Nghĩa {n}',
        imageN: 'Hình {n}',
        videoN: 'Video {n}',
        additionalMaterials: 'Tài liệu bổ sung',
    },
    result: {
        myAnswer: 'Câu trả lời của tôi:',
        know: 'Biết',
        dontKnow: 'Không biết',
        dontKnowBracket: '(Không biết)',
    },
    stats: {
        mostIncorrect: 'Từ sai nhiều nhất',
        vocabulary: 'Từ vựng',
        meaning: 'Nghĩa',
        accuracy: 'Độ chính xác',
        moreN: 'và {n} từ khác',
    },
    reactions: {
        knowSelect: [
            'Ồ! Bạn tự tin quá!',
            'Tuyệt! Cùng kiểm tra nhé!',
            'Hay lắm! Xem bạn đúng không nhé!',
            'Giỏi quá! Đó là từ gì nhỉ?',
            'Tuyệt vời! Cùng xem đáp án nào!',
        ],
        correct: [
            'Đúng rồi! Bạn giỏi lắm!',
            'Wow! Bạn biết chính xác luôn!',
            'Chính xác! Tuyệt vời!',
            'Xuất sắc! Bạn trả lời đúng hoàn toàn!',
            'Giỏi lắm! Thật ấn tượng!',
        ],
        dontKnowSelect: [
            'Không sao! Cùng tìm hiểu nhé!',
            'Đừng lo! Xem ví dụ sẽ biết thôi!',
            'Không vấn đề! Cùng xem gợi ý nhé!',
        ],
        maxAttempts: 'Không sao. Cùng tìm hiểu từ vựng này nhé!',
        maxAttemptsNext: 'Hãy xem từ vựng là gì và chuyển sang từ tiếp theo!',
    },
    teacher: {
        modal: {
            clearConfirm: {
                title: 'Xóa tất cả từ vựng đang chờ?',
                message: 'Tất cả từ vựng đang chờ sẽ bị xóa. Tiếp tục?',
            },
            closeConfirm: {
                title: 'Hủy nội dung đã nhập?',
                message: 'Đóng sẽ xóa tất cả từ trong danh sách chờ. Tiếp tục?',
            },
            questionDelete: {
                title: 'Xóa câu hỏi này?',
                // {word}: từ đầu mục của câu hỏi cần xóa. Cảnh báo sẽ bị xóa vĩnh viễn khỏi hoạt động.
                message: "Câu hỏi '{word}' sẽ bị xóa khỏi hoạt động. Tiếp tục?",
            },
            waitItemDelete: {
                title: 'Xóa từ vựng đang chờ?',
                // {word}: từ vựng đang chờ cần xóa. Chỉ xóa khỏi hàng đợi; hoạt động không bị ảnh hưởng.
                message: "Xóa '{word}' khỏi danh sách chờ. Tiếp tục?",
            },
            // {count}: số từ bị bỏ qua do trùng lặp trong từ điển
            duplicateNotice: '{count} từ đã được đăng ký nên không được thêm.',
            // {count}: số từ bị bỏ qua vì không có nghĩa
            skippedNotice: '{count} từ không có nghĩa nên không được thêm.',
            // Xác nhận khi trộn lẫn từ không có nghĩa với từ hợp lệ
            mixedEmptyConfirm: {
                title: 'Đăng ký?',
                line1: '{empty} từ không có nghĩa sẽ không được thêm.',
                line2: 'Chỉ đăng ký {valid} từ còn lại?',
            },
            // Thông báo khi chỉ còn lại từ không có nghĩa
            onlyEmptyNotice: {
                title: 'Không thể đăng ký',
                message: 'Không có từ nào để đăng ký. Chỉ còn lại các từ không có nghĩa.',
            },
            registerFailed: 'Không thể thêm.',
        },
    },
};
